import classNames from 'classnames';
import type { ReactNode } from 'react';

interface SoftBadgeProps {
  bg?: string;
  pill?: boolean;
  children?: ReactNode;
  className?: string;
}

const SoftBadge = ({
  bg = 'primary',
  pill,
  children,
  className,
}: SoftBadgeProps) => {
  return (
    <div
      className={classNames(className, `badge badge-soft-${bg}`, {
        'rounded-pill': pill,
      })}
    >
      {children}
    </div>
  );
};

export default SoftBadge;
